<template>
    <div class="olf-wave-background d-flex justify-content-center align-items-center">
        <div class="login-sequence-box text-center card"
            :class="[$breakpoint.xsOnly ? 'p-4' : 'p-5']"
        >
            <img src="/assets/rebrandLogo2.png" alt="Online Fuels Logo" class="d-block mb-5 logo" />
            <form class="login w-100" @submit.prevent="loginUser">
                <h1 class="heading-xlarge text-center my-3">Login</h1>
                <div class="form-group">
                    <label for="inputUsername">Username</label>
                    <input tabindex="1" id="username" class="w-100" v-model="user.username" @click="clearError" type="text" placeholder="Enter your username" required />
                </div>
                <div class="form-group">
                    <label for="inputPassword">Password</label>
                    <input tabindex="2" id="password" class="w-100" v-model="user.password" @click="clearError" type="password" placeholder="Enter your password" required />
                </div>
                <div class="form-group">
                    <router-link tabindex="5" id="forgot-password" to="/requestNewPassword">Forgot your password?</router-link>
                </div>
                <div class="text-center">
                    <button type="submit" tabindex="3" class="btn btn-primary">Sign In</button>
                </div>
                
            </form>
            <span class="error-message">{{error}}</span>
            <div class="contact-link">
                Need a new account? <a href="mailto:info@onlinefuels.com?Subject=New%20account%20request" target="_top">Contact us</a>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions } from "vuex";
import breakpoint from '@/mixins/index';

export default {
    mixins: [breakpoint],
    data() {
        return{
            user:{
                username:'',
                password:''
            },
            error:''
        } 
    },
    created: function() {
    },
    methods: {
        ...mapActions('login',['logUserIn', 'updateTermsAcceptedStatus']),
        clearError: function() {
            this.error = '';
        },
        loginUser: async function() {
            if ((this.user.username !== '' && this.user.password !== '')){
                let user = this.user;
                const response = await this.axios.post('/api/login', user)
                if (response.data.success) {
                    this.logUserIn(response);
                    localStorage.setItem('session', JSON.stringify(response.data.user));
                    const userCategory = response.data.user.account.type;
                    /* Check whether user has accepted T&C */
                    try {
                        const tcResponse = await this.axios.get('/api/getTermsAndConditionsStatus', {params: {
                            userId: response.data.user.userId,
                            key: 'TC_ACCEPTED'
                        }})

                        localStorage.setItem('terms_accepted', true);
                        this.updateTermsAcceptedStatus(true)
                        this.$router.push({ name: 'Dashboard' });
                    }
                    catch (ex){
                        localStorage.setItem('terms_accepted', false)
                        this.updateTermsAcceptedStatus(false)
                        this.$router.push({ name: 'TermsAndConditions' });
                    }
                }
                else {
                    this.error= 'Invalid username or password.  You will be locked out after 5 attempts. To unlock your user account, please contact us.';
                    localStorage.removeItem('session')
                    localStorage.removeItem('terms_accepted')
                    this.updateTermsAcceptedStatus(false)
                }
            }
        }
    }
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/pages/_logins.scss";
</style>
